import { IPlan } from "../types/types";

export const dateMap = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "June",
  "Jul",
  "Aug",
  "Sept",
  "Oct",
  "Nov",
  "Dec",
];
export const EXHUT_WEB_LOCAL_STORAGE_GROUPID = "exhut-web-group-id";
export const EXHUT_WEB_LOCAL_STORAGE_TOKEN = "exhut-web-token";
export const EXHUT_WEB_REDIRECT = "exhut-web-redirect-url";
export const EXHUT_SAVINGS_GOAL_TOTAL = "exhut-web-savings-goal-total";

export enum ROUTES {
  DASHBOARD = "/dashboard",
  HOME = "/home",
  BASE = "/",
  REGISTER = "/register",
  LOGIN = "/login",
  ADMIN = "/admin",
  jobs = "",
  register = "/register",
  forgotPassword = "/forgot-password",
}

export function getSubscription(entitlement: string | number | undefined) {
  if (entitlement) {
    switch (entitlement) {
      case 0:
        return "TRIAL";
      case 1:
        return "BASIC";
      case 2:
        return "STANDARD";
      case 3:
        return "PREMIUM";
      case 10:
        return "UNLIMITED";
    }
  } else {
    return "TRIAL";
  }
}

enum Countries {
  AUS = "AUS",
  BW = "BW",
  CAN = "CAN",
  CHN = "CHN",
  IND = "IND",
  SGP = "SGP",
  UK = "UK",
  USA = "USA",
}

export enum COUNTRY_CODE {
  AUSTRALIA = "AUS",
  BRAZIL = "BRA",
  CANADA = "CAN",
  FRANCE = "FRA",
  INDIA = "IND",
  INDONESIA = "ID",
  MEXICO = "MX",
  SINGAPORE = "SGP",
  UK = "UK",
  USA = "USA",
}

export function getCountryPhoneCode(country?: string) {
  switch (country) {
    case Countries.AUS:
      return "+61";
    case Countries.BW:
      return "+267";
    case Countries.CAN:
      return "+1";
    case Countries.CHN:
      return "+86";
    case Countries.IND:
      return "+91";
    case Countries.SGP:
      return "+65";
    case Countries.UK:
      return "+44";
    case Countries.USA:
      return "+1";
    default:
      return "";
  }
}

export function getCountryFullName(countryCode?: string): string {
  switch (countryCode) {
    case Countries.AUS:
      return "Australia";
    case Countries.BW:
      return "Botswana";
    case Countries.CAN:
      return "Canada";
    case Countries.CHN:
      return "China";
    case Countries.IND:
      return "India";
    case Countries.SGP:
      return "Singapore";
    case Countries.UK:
      return "United Kingdom";
    case Countries.USA:
      return "United States Of America";
    default:
      return "";
  }
}

export const FeatureFlags = {
  ENABLE_BUSINESS: "enable-business",
  ENABLE_SUBSCRIPTIONS: "enable-subscriptions",
  ENABLE_BUSINESS_CUSTOMER_LOGIN: "enable-business-customer-login",
};

export const plans: IPlan[] = [
  {
    id: 0,
    name: "Starter Plan",
    price: 1.29,
    period: "per month",
    bgColor: "bg-gradient-to-r from-blue-500 to-blue-700",
    description: "Sync upto 1 account",
    highlight: true,
    features: [
      "Sync upto 1 bank account",
      "Join unlimited number of groups",
      "Create upto 5 groups",
      "Track personal expenses",
      "Basic expense categorization",
      "Upto 3 Trips Per Month.",
      "Unlimited Trip Expenses",
      "Upto 1 Personal Ledger",
      "Basic charts & analytics",
      "Mobile app access",
      "Email support",
    ],
    gradient: "from-emerald-400 to-green-500",
    buttonColor: "bg-blue-500 hover:bg-blue-600",
    borderColor: "border-emerald-200",
  },
  {
    id: 1,
    name: "Premium Plan",
    price: 2.49,
    period: "per month",
    bgColor: "bg-gradient-to-r from-amber-300 to-amber-500",
    badge: "Recommended",
    badgeColor: "bg-green-500",
    description: "Sync upto 3 accounts",
    highlight: false,
    features: [
      "Sync upto 3 bank accounts",
      "Everything in Starter, plus:",
      "Create unlimited number of groups",
      "Unlimited expense tracking",
      "Unlimited groups",
      "Multi-user collaboration",
      "Upto 10 trips Per Month.",
      "Unlimited Trip expense tracking",
      "50 Ledgers",
      "Multi-currency & forex conversion",
      "Savings goal tracking",
      "Email support",
    ],
    gradient: "from-emerald-400 to-green-500",
    buttonColor: "bg-amber-500 hover:bg-amber-600",
    borderColor: "border-emerald-200",
  },
  /*
  {
    id: 2,
    name: "Premium Plan",
    price: 4.99,
    period: "per month",
    bgColor: "bg-gradient-to-r from-gray-400 to-gray-600",
    description: "Sync upto 5 accounts",
    highlight: false,
    features: [
      "Everything in Basic, plus:",
      "Sync upto 5 accounts",
      "Unlimited Ledgers",
      "Unlimited Trips",
      "Savings goal tracking",
      "Priority support",
      "Monthly reports",
      "Monthly Mobile Notifications (Coming Soon..)",
    ],
    gradient: "from-gray-400 to-gray-500",
    buttonColor: "bg-gray-500 hover:bg-gray-600",
    borderColor: "border-amber-200",
  }, */
];
